export default __webpack_public_path__ + "static/media/Rod of Righteous Might.d3da9a69.jpg";